import api from '../../api';
import { TPunterSearchParams, TPunterSearch } from './search.types';

const punterSearchURL = '/bookie/punters/search';

// Punter profile - Search
export const queryPunterSearch = (params: TPunterSearchParams) =>
  api.get<TPunterSearch[]>(punterSearchURL, { params }).then((res) => res.data);
